import { render, staticRenderFns } from "./VersionChip.vue?vue&type=template&id=ce837c1e&"
import script from "./VersionChip.vue?vue&type=script&lang=js&"
export * from "./VersionChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports